/**
 * @generated SignedSource<<18eb5fc6b360e7dd58c85d75f12cef52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TrelloListSelectorQuery$variables = {
  boardId: string;
};
export type TrelloListSelectorQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly trello: {
        readonly lists: ReadonlyArray<{
          readonly externalId: string;
          readonly id: string;
          readonly name: string;
        }> | null;
      } | null;
    };
  };
};
export type TrelloListSelectorQuery = {
  response: TrelloListSelectorQuery$data;
  variables: TrelloListSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "boardId",
      "variableName": "boardId"
    }
  ],
  "concreteType": "TrelloListNode",
  "kind": "LinkedField",
  "name": "lists",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TrelloListSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TrelloUserNode",
                "kind": "LinkedField",
                "name": "trello",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TrelloListSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TrelloUserNode",
                "kind": "LinkedField",
                "name": "trello",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "163bc1a48ebb602f598ecbfa1ade1357",
    "id": null,
    "metadata": {},
    "name": "TrelloListSelectorQuery",
    "operationKind": "query",
    "text": "query TrelloListSelectorQuery(\n  $boardId: String!\n) {\n  viewer {\n    integrations {\n      trello {\n        lists(boardId: $boardId) {\n          id\n          name\n          externalId\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0dfced8874b6a53ed64876c23d3fe901";

export default node;
